import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-rank',
  templateUrl: './my-rank.component.html',
  styleUrls: ['./my-rank.component.scss']
})
export class MyRankComponent implements OnInit {
  
  rankListLmt = [
    {
      username: 'John S.',
      imagepath: 'assets/images/common-avatars/avatar-(16).jpg',
      rank: 'Level 30'
    },
    {
      username: 'Devid D',
      imagepath: 'assets/images/common-avatars/avatar-(17).jpg',
      rank: 'Level 40'
    },
    {
      username: 'N. Sharma',
      imagepath: 'assets/images/common-avatars/avatar-(18).jpg',
      rank: 'Level 20'
    },
    {
      username: 'Pushpa Sharma',
      imagepath: 'assets/images/common-avatars/avatar-(19).jpg',
      rank: 'Level 60'
    }  
  ]

  rankList = [
    {
      username: 'John S.',
      imagepath: 'assets/images/common-avatars/avatar-(16).jpg',
      rank: 'Level 30'
    },
    {
      username: 'Devid D',
      imagepath: 'assets/images/common-avatars/avatar-(17).jpg',
      rank: 'Level 40'
    },
    {
      username: 'N. Sharma',
      imagepath: 'assets/images/common-avatars/avatar-(18).jpg',
      rank: 'Level 20'
    },
    {
      username: 'Sarabjot Singh Anand',
      imagepath: 'assets/images/common-avatars/avatar-(21).jpg',
      rank: 'Level 80'
    },
    {
      username: 'Taranjot Singh',
      imagepath: 'assets/images/common-avatars/avatar-(21).jpg',
      rank: 'Level 10'
    },
    {
      username: 'Lorem Ipsum',
      imagepath: 'assets/images/common-avatars/avatar-(22).jpg',
      rank: 'Level 60'
    },
    {
      username: 'Lorem Ipsum',
      imagepath: 'assets/images/common-avatars/avatar-(23).jpg',
      rank: 'Level 90'
    },
    {
      username: 'Lorem Ipsum',
      imagepath: 'assets/images/common-avatars/avatar-(24).jpg',
      rank: 'Level 40'
    },
    {
      username: 'Lorem Ipsum',
      imagepath: 'assets/images/common-avatars/avatar-(25).jpg',
      rank: 'Level 80'
    },
    {
      username: 'Lorem Ipsum',
      imagepath: 'assets/images/common-avatars/avatar-(26).jpg',
      rank: 'Level 30'
    },
    {
      username: 'Lorem Ipsum',
      imagepath: 'assets/images/common-avatars/avatar-(27).jpg',
      rank: 'Level 50'
    },
    {
      username: 'Lorem Ipsum',
      imagepath: 'assets/images/common-avatars/avatar-(28).jpg',
      rank: 'Level 50'
    },
    {
      username: 'Lorem Ipsum',
      imagepath: 'assets/images/common-avatars/avatar-(29).jpg',
      rank: 'Level 70'
    }
  ];

  constructor() { }

  ngOnInit() {
  }

}
